import { createFileRoute } from '@tanstack/react-router';
import { WizardStepRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';
import { ImportReviewPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function ImportReviewRoute() {
  return (
    <LastWorkspaceResolver>
      <WizardStepRouteView step="review">
        <ImportReviewPage />
      </WizardStepRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review')({
  validateSearch: validateWizardSearch,
  component: ImportReviewRoute,
});
